import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const bubbleFn = /* @__PURE__ */ createRecipe('bubble', {
  "variant": "filled",
  "shape": "rounded",
  "color": "primary",
  "size": "l"
}, [
  {
    "variant": "filled",
    "color": "primary",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "primary.background.2.enabled"
    }
  },
  {
    "variant": "filled",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.2.onBrand.enabled",
      "backgroundColor": "neutral.background.2.enabled"
    }
  },
  {
    "variant": "outlined",
    "color": "primary",
    "css": {
      "color": "primary.foreground.1.enabled",
      "borderColor": "primary.stroke.2.enabled"
    }
  },
  {
    "variant": "outlined",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.1.enabled",
      "borderColor": "neutral.stroke.2.enabled"
    }
  }
])

const bubbleVariantMap = {
  "variant": [
    "unstyled",
    "filled",
    "outlined"
  ],
  "shape": [
    "unstyled",
    "rounded",
    "square"
  ],
  "color": [
    "unstyled",
    "primary",
    "neutral"
  ],
  "size": [
    "l",
    "m",
    "s"
  ]
}

const bubbleVariantKeys = Object.keys(bubbleVariantMap)

export const bubble = /* @__PURE__ */ Object.assign(memo(bubbleFn.recipeFn), {
  __recipe__: true,
  __name__: 'bubble',
  __getCompoundVariantCss__: bubbleFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: bubbleVariantKeys,
  variantMap: bubbleVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, bubbleVariantKeys)
  },
  getVariantProps: bubbleFn.getVariantProps,
})